import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import profilesService from './../../services/profiles';

import ProductTagsListItem from './ProductTagsListItem';
import ProductTagsListSearch from './ProductTagsListSearch';
import DialogEditProductTag from './../dialog/DialogEditProductTag';
import List from './../commons/List';
import { PlusIcon } from './../commons/Icons';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

class ProductTagsList extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      tags: [],
      loading: false,
      reload: false,
      openDialog_edit: false,
      openDialog_edit_item: null,
    };
  }

  componentDidMount () {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    const reload = JSON.stringify(this.props.query) !== JSON.stringify(prevProps.query);
    if (reload) {
      this._isMounted && this.setState({ reload: !this.state.reload });
    }
  }

  load (limit, offset, searchQuery) {
    return profilesService.getAllProductTags(this.props.id_profile, {...this.props.query, ...searchQuery, ...{limit, offset}}).then(([items]) => items);;
  }

  onProductTagSaved (savedProductTag, is_new) {
    const { selectAfterCreate } = this.props;
    if (is_new) {
      this._isMounted && this.setState({tags: [...[savedProductTag], ...this.state.tags]});
      if (selectAfterCreate) {
        this.props.onSelect(savedProductTag);
      }
    } else {
      this._isMounted && this.setState(prevState => ({
        tags: prevState.tags.map((product) => {
          if (product.ID === savedProductTag.ID) {
            return savedProductTag;
          }
          return product;
        })
      }));
    }
  }

  onProductTagDeleted (id_deletedProductTag) {
    this._isMounted && this.setState(prevState => ({
      tags: prevState.tags.filter((product) => {
        return product.ID !== id_deletedProductTag;
      })
    }))
  }

  openEdit (item = null) {
    this._isMounted && this.setState({ openDialog_edit_item: item, openDialog_edit: true });
  }

  closeEdit () {
    this._isMounted && this.setState({ openDialog_edit_item: null, openDialog_edit: false });
  }

  editOnSelect = (item) => {
    this.openEdit(item);
  }

  render() {
    const { classes, id_profile, query } = this.props;
    const { tags, loading, reload } = this.state;

    const onSelect = this.props.onSelect || (this.props.canUpdate && this.editOnSelect);

    return (
      <Box className={classes.content}>

        { (this.props.canCreate || this.props.canUpdate) && (
          <React.Fragment>
            { this.state.openDialog_edit && (
              <DialogEditProductTag
                open={ this.state.openDialog_edit }
                tag={ this.state.openDialog_edit_item }
                id_profile={ id_profile }
                preset={ query }
                onSaved={ (product, is_new) => {
                  this.onProductTagSaved(product, is_new);
                  this.closeEdit();
                } }
                onDeleted={ (id) => {
                  this.onProductTagDeleted(id);
                  this.closeEdit();
                } }
                onError={ this.props.onError }
                onClose={ () => this.closeEdit() }
              />
            ) }
            { this.props.canCreate && (
              <Box className={classes.actions}>
                <Button variant="outlined" color="primary" className={classes.button} startIcon={<PlusIcon />} onClick={ () => this.openEdit() }>Tag</Button>
              </Box>
            ) }
          </React.Fragment>
        ) }

        <List
          title={this.props.title}
          reload={reload}
          load={(limit, offset, searchQuery) => this.load(limit, offset, searchQuery)}
          loaded={(items) => this._isMounted && this.setState({tags: items})}
          searchEnabled={this.props.searchEnabled}
          renderSearch={(onInitialize, searchQuery, onQueryChange) => (
            <ProductTagsListSearch
              query={searchQuery}
              onQueryChange={onQueryChange}
              onInitialize={onInitialize}
              searching={loading}
              onError={this.props.onError}
              expanded={this.props.searchExpanded}
            />
          )}
          defaultSearchQuery={this.props.defaultSearchQuery}
          listOnlyOnSearch={this.props.listOnlyOnSearch}
          onSelect={onSelect}
          selectedItemsKeys={this.props.selectedItemsKeys}
          onError={this.props.onError}
          onSuccess={this.props.onSuccess}
          infiniteScrollProps={ {
            limit: this.props.limit || 25,
            scrollableTarget: this.props.scrollableTarget,
            items: tags,
            onLoading: (loading) => this._isMounted && this.setState({loading}),
            noResult: this.props.noResult,
          } }
          renderItem={ (tag, selectable) => (
            <ProductTagsListItem
              id_profile={ id_profile }
              tag={tag}
              onSaved={ (tag, is_new) => this.onProductTagSaved(tag, is_new) }
              onDeleted={ (id_tag) => this.onProductTagDeleted(id_tag) }
              onError={this.props.onError}
              onSuccess={this.props.onSuccess}
              right={this.props.listItemRight}
              disableExpand={selectable}
            />
          ) }
        />

      </Box>
    )
  }
}

const styles = theme => ({
  content: {
  },
  title: {
    padding: theme.spacing(1, 2),
  },
  actions: {
    padding: theme.spacing(2),
  },
  button: {
    width: '100%',
  }
});

ProductTagsList.propTypes = {
  id_profile: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  limit: PropTypes.number,
  title: PropTypes.string,
  onSelect: PropTypes.func,
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  query: PropTypes.object,
  noResult: PropTypes.element,
  scrollableTarget: PropTypes.string,
  selectedItemsKeys: PropTypes.array,

  searchEnabled: PropTypes.bool,
  searchExpanded: PropTypes.bool,
  listOnlyOnSearch: PropTypes.bool,
  defaultSearchQuery: PropTypes.object,

  canCreate: PropTypes.bool,
  canUpdate: PropTypes.bool,
  selectAfterCreate: PropTypes.bool,

  listItemRight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
};

ProductTagsList.defaultProps = {
  searchEnabled: true,
};

export default withStyles(styles, { withTheme: true })(ProductTagsList);
